<template>
  <div class="header-wrap">
    <div v-if="isLogin" class="brand-wrap">
      <slot name="header-left">
        {{ platformName }}
      </slot>
    </div>
    <div v-if="isMenu" class="menu" @click="menuClick">
      <div class="line" />
      <div class="line" />
      <div class="line" />
    </div>
    <div v-if="isLogin" class="header-right">
      <a-tag v-if="isMock" color="red">
        Mock API
      </a-tag>
      <a-dropdown>
        <a class="ant-dropdown-link">
          Hi, {{ nickname }}
          <a-icon type="down" />
        </a>
        <a-menu slot="overlay">
          <a-menu-item @click="logout">
            {{ $t('i18n_logout') }}
          </a-menu-item>
          <!-- <a-sub-menu>
            <span slot="title">{{ $t('i18n_switch_lang') }}</span>
            <a-menu-item @click="reloadLanguage('zh-CN')">
              {{ $t('i18n_lang_cn') }}
            </a-menu-item>
            <a-menu-item @click="reloadLanguage('zh-TW')">
              {{ $t('i18n_lang_tw') }}
            </a-menu-item>
          </a-sub-menu> -->
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
import { setStorage } from '@GUTIL/other'
import { mapGetters } from 'vuex'

export default {
  name: 'Header',
  props: {
    isMenu: Boolean,
    isLogin: Boolean
  },
  data() {
    return {
      nickname: ''
    }
  },
  computed: {
    ...mapGetters(['folderName', 'meInfo']),
    platformName() {
      let hasVal = !!this.folderName
      return hasVal
        ? this.$t(`i18n_xnb_${this.folderName.toLowerCase()}_platform`)
        : ''
    },
    isMock() {
      return process.env.NODE_ENV == 'localhost'
    }
  },
  watch: {
    meInfo: {
      handler: function() {
        this.nickname = this.meInfo.nickname
      },
      immediate: true
    }
  },
  methods: {
    async logout() {
      await this.$authProvider.logout()
      this.$router.push({ name: 'Login' })
    },
    menuClick() {
      this.$emit('menuClick') //定義menuClick事件 GlobalLayout 會呼叫到
    },
    reloadLanguage(lang) {
      setStorage('lang', lang)
      window.location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .ant-dropdown-menu-item {
  text-align: center;
}

/deep/ .ant-dropdown-menu-submenu-title {
  padding-left: 26px;
  padding-right: 12px;
  text-align: center;
}

/deep/ .ant-dropdown-menu-submenu-title .ant-dropdown-menu-submenu-arrow {
  right: auto;
  left: 2px;
  transform: rotate(180deg);
}
</style>
